import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { signUpUrl } from 'utils/config';
import { ctaButton } from './CTAButton.module.scss';

const CTAButton = ({ url }) => (
  <a href={url} className={cn(ctaButton, "smeCTA")}>免費試用</a>
)
CTAButton.propTypes = {
  url: PropTypes.string.isRequired,
}
CTAButton.defaultProps = {
  url: signUpUrl,
}

export default CTAButton;